import { render, staticRenderFns } from "./PromptDialog.vue?vue&type=template&id=5235b9c5&scoped=true&"
import script from "./PromptDialog.vue?vue&type=script&lang=js&"
export * from "./PromptDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235b9c5",
  null
  
)

export default component.exports